/** Число мс для сортировки заказов по дате (ISO или массив LocalDateTime из Jackson). */
export function orderDateTimeMs(value) {
    if (value == null) return 0;
    if (typeof value === 'string') {
        const t = new Date(value).getTime();
        return Number.isNaN(t) ? 0 : t;
    }
    if (Array.isArray(value) && value.length >= 3) {
        const [y, m, day, hh = 0, mm = 0, ss = 0] = value;
        return new Date(y, m - 1, day, hh, mm, ss).getTime();
    }
    return 0;
}

/**
 * Форматирует дату заказа из API (ISO-строка или массив LocalDateTime из Jackson).
 */
export function formatOrderDate(value) {
    if (value == null) return '—';
    if (typeof value === 'string') {
        const d = new Date(value);
        return Number.isNaN(d.getTime())
            ? value
            : d.toLocaleString('ru-RU', {dateStyle: 'short', timeStyle: 'short'});
    }
    if (Array.isArray(value) && value.length >= 3) {
        const [y, m, day, hh = 0, mm = 0, ss = 0] = value;
        const d = new Date(y, m - 1, day, hh, mm, ss);
        return d.toLocaleString('ru-RU', {dateStyle: 'short', timeStyle: 'short'});
    }
    return '—';
}
